export default {
  get verbose() {
    try {
      const localStorageVerboseFlag = localStorage.getItem('Z_VERBOSE');
      return process.env.Z_VERBOSE || localStorageVerboseFlag;
    } catch (e) {
      console.warn('Unable to read verbose log level configuration');
      return false;
    }
  },
};
